import { useEffect, useRef, useState } from "react";
import { ScanLine, CheckCircle2, Trash2 } from "lucide-react";
import { Input } from "../components/ui/input";
import { Button } from "../components/ui/button";

export default function AdminScanTest() {
  const [buffer, setBuffer] = useState("");
  const [scans, setScans] = useState([]);
  const [lastKey, setLastKey] = useState("");
  const inputRef = useRef(null);

  useEffect(() => { inputRef.current?.focus(); }, []);

  const onKeyDown = (e) => {
    setLastKey(e.key);
    if (e.key === "Enter") {
      e.preventDefault();
      if (buffer.trim()) {
        setScans((s) => [{ id: Date.now(), text: buffer.trim(), len: buffer.trim().length, time: new Date().toLocaleTimeString("ro-RO") }, ...s.slice(0, 19)]);
        setBuffer("");
      }
    }
  };

  return (
    <div data-testid="admin-scan-test">
      <div className="flex items-center gap-3 mb-2">
        <ScanLine className="w-8 h-8 text-[#00E5FF]" />
        <h1 className="font-display text-4xl uppercase">Test scanner Zebra</h1>
      </div>
      <p className="text-sm text-neutral-400 mb-8">
        Pagina simpla pentru a verifica daca scanner-ul tau e in modul HID Keyboard. Pur si simplu scaneaza orice cod de bare.
      </p>

      <div className="bg-neutral-950 border-2 border-[#00E5FF] p-6 mb-6">
        <div className="text-xs uppercase tracking-[0.3em] text-[#00E5FF] font-bold mb-3">// Camp de test</div>
        <Input
          ref={inputRef}
          value={buffer}
          onChange={(e) => setBuffer(e.target.value)}
          onKeyDown={onKeyDown}
          placeholder="Scaneaza orice cod aici..."
          className="bg-neutral-900 border-[#00E5FF] rounded-none h-16 text-2xl font-mono"
          autoFocus
        />
        <div className="text-xs text-neutral-500 mt-2">Ultima tasta primita: <span className="text-[#00E5FF] font-mono">{lastKey || "—"}</span> (la final trebuie sa fie <span className="text-green-400">Enter</span>)</div>
      </div>

      <div className="grid sm:grid-cols-3 gap-3 mb-6">
        <Diagnostic label="Scanari OK" value={scans.length} ok={scans.length > 0} />
        <Diagnostic label="Lungime cod scanat" value={scans[0]?.len || 0} ok={scans.length > 0} />
        <Diagnostic label="Enter detectat" value={scans.length > 0 ? "DA" : "—"} ok={scans.length > 0} />
      </div>

      {scans.length > 0 && (
        <div className="bg-neutral-950 border border-neutral-800 p-5">
          <div className="flex items-center justify-between mb-3">
            <h3 className="font-display text-lg uppercase">Scanari ({scans.length})</h3>
            <Button onClick={() => setScans([])} variant="outline" className="rounded-none border-neutral-700 h-8 text-xs"><Trash2 className="w-3 h-3 mr-1" /> Curata</Button>
          </div>
          <div className="space-y-1">
            {scans.map((s) => (
              <div key={s.id} className="flex items-center gap-3 text-sm border-b border-neutral-900 py-1.5">
                <CheckCircle2 className="w-4 h-4 text-green-400 flex-shrink-0" />
                <span className="text-[10px] text-neutral-500 w-16 font-mono">{s.time}</span>
                <span className="flex-1 font-mono text-white break-all">{s.text}</span>
                <span className="text-[10px] text-neutral-500">{s.len} caract.</span>
              </div>
            ))}
          </div>
        </div>
      )}

      <div className="mt-8 bg-neutral-950 border border-neutral-800 p-5 text-sm">
        <h3 className="font-display text-lg uppercase mb-3 text-[#00E5FF]">Cum interpretez rezultatele?</h3>
        <ul className="space-y-2 text-neutral-300">
          <li>✅ <strong>Codul apare in lista si Enter detectat</strong> — perfect, scanner-ul e in modul corect, totul merge</li>
          <li>⚠️ <strong>Codul apare in camp dar NU se adauga in lista</strong> — scanner-ul nu trimite Enter la final. Trebuie configurat suffix=CR/LF din 123Scan</li>
          <li>❌ <strong>Nu se intampla nimic cand scanezi</strong> — scanner-ul e in mod SDK/Symbol Native. Treci-l pe USB HID Keyboard din 123Scan</li>
        </ul>
      </div>
    </div>
  );
}

const Diagnostic = ({ label, value, ok }) => (
  <div className={`bg-neutral-950 border p-4 ${ok ? "border-green-500/40" : "border-neutral-800"}`}>
    <div className={`font-display text-3xl ${ok ? "text-green-400" : "text-neutral-500"}`}>{value}</div>
    <div className="text-xs uppercase tracking-widest text-neutral-500 mt-1">{label}</div>
  </div>
);
